import "../stylesheets/styles.scss";
import "./lib/flash-message";
import "./lib/modal-utils";
import "./lib/sidebar";
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import Rails from 'rails-ujs';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import Sortable from 'sortablejs';
import {WowmaCategories} from "./WowmaCategories";
import SearchBox from "./SearchBox";
import SearchInput from "./SearchInput";
import SearchRange from "./SearchRange";
import SearchDateRange from "./SearchDateRange";
import SearchOrder from "./SearchOrder";
import SearchSubmit from "./SearchSubmit";
import './draw-histories';
import './clipboard';
import './csvs';
Rails.start();
window.Rails = Rails;
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';
import FilterCheckbox from "./FilterCheckbox";
import DatePicker from "./DatePicker";
import DataViewer from "./DataViewer";
import {csrfToken, normalizeKanji, showLoader} from "./lib/utils";
import SearchSelect from "./SearchSelect";
import SearchCategory from "./SearchCategory";
import "chartkick/chart.js"
import copy from 'clipboard-copy';
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import {PriceSettingsSets} from "./price-setting/PriceSettingsSets";

const render = (component, container) => {
  const root = createRoot(container);
  root.render(component);
}
import chunk from "lodash/chunk";
import {RemoteIslandsForm} from "./RemoteIslandsForm";
import {NgBuyersForm} from "./NgBuyersForm";
import {DebugLogViewer} from "./DebugLogViewer";
import UserDictionaryPreview from "./UserDictionaryPreview";

const showRenewalApiKeyModal = () => {
    const modal = document.getElementById('renewalApiKeyModal');
    if (!modal) return;
    showModal(modal);
};

const showPriceSettings = () => {
    const element = document.getElementById('price-settings');
    if (element) {
        const data = element.getAttribute('data-settings');
        const url = element.getAttribute('data-url');
        const action = element.getAttribute('data-action') || 'PUT';
        render(<PriceSettingsSets data={data} url={url} action={action}/>, element);
    }
};

const renderEach = (selector, factory) => {
    document.querySelectorAll(selector).forEach((elem) => {
        render(factory(elem), elem);
    });
};

const showProductSearch = () => {
    renderEach('.search-box', (element) => {
        const url = element.getAttribute('data-url');
        const placeholder = element.getAttribute('data-placeholder');
        const q = element.getAttribute('data-q');
        return <SearchBox url={url} placeholder={placeholder} q={q} />;
    });
    renderEach('.filter-checkbox', (element) => {
        const url = element.getAttribute('data-url');
        const name = element.getAttribute('data-name');
        const label = element.getAttribute('data-label');
        const value = element.getAttribute('data-value') === '1';
        return <FilterCheckbox url={url} name={name} label={label} value={value} />;
    });
    renderEach('.search-input', (elem) => <SearchInput {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-range', (elem) => <SearchRange {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-date-range', (elem) => <SearchDateRange {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-order', (elem) => <SearchOrder {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-submit', (elem) => <SearchSubmit {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-select', (elem) => <SearchSelect {...Object.assign({}, elem.dataset)} />);
    renderEach('.search-category', (elem) => {
        const props = Object.assign({}, elem.dataset);
        props.categories = window.gon?.service_categories || '';
        return <SearchCategory {...props} />;
    });
    renderEach('.remote-islands-form', (elem) => <RemoteIslandsForm {...Object.assign({}, elem.dataset)} />);
    renderEach('.ng-buyers-form', (elem) => <NgBuyersForm {...Object.assign({}, elem.dataset)} />);
    renderEach('.debug-log-viewer', (elem) => {
        const users = JSON.parse(elem.getAttribute('data-users') || '[]');
        return <DebugLogViewer users={users} />;
    });
};
const showDatePickers = () => {
    document.querySelectorAll('.datepicker').forEach((element) => {
        const name = element.getAttribute('data-name');
        const value = element.getAttribute('data-value');
        render(<DatePicker name={name} value={value} />, element);
    });
};

const checkUserMailSettings = () => {
    const completeOrder = document.getElementById('complete-order');
    if (!completeOrder) return;
    completeOrder.addEventListener('shown.bs.modal', () => {
        Rails.ajax({
            type: 'POST', url: '/settings/check/mail-settings.js'});
    });
};

const initToggleAll = () => {
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.toggle-all');
        if (!trigger) return;
        const target = trigger.dataset.target;
        if (!target) return;
        document.querySelectorAll(target).forEach((el) => {
            el.checked = trigger.checked;
        });
    });

    Array.from(document.querySelectorAll('.with-toggle-all')).forEach(el =>
        el.addEventListener('submit', (e) => {
            e.preventDefault();
            const form = el;
            Array.from(document.querySelectorAll('.toggle-delete')).forEach(input => {
                input.setAttribute('form', form.id);
            });
            // 即時削除のように formaction を持つボタンで送ったときは、その送り先にする (form.submit() は formaction を見ない)
            const formAction = e.submitter?.getAttribute('formaction');
            if (formAction) form.action = formAction;
            showLoader();
            form.submit();
        }))
};

// 即時削除は 5 件まで。超えて選んでいたら確認のダイアログを出し、「5件削除」で先頭の 5 件だけを送る。
// rails-ujs の確認ダイアログより先に動くよう、capture で受ける
const IMMEDIATE_DELETE_LIMIT = 5;
const deleteNowModal = () => {
    let el = document.getElementById('delete-now-limit-modal');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'delete-now-limit-modal';
    el.className = 'modal fade';
    el.tabIndex = -1;
    el.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <p>即時削除は一度に${IMMEDIATE_DELETE_LIMIT}件までです。選んだ商品のうち先頭の${IMMEDIATE_DELETE_LIMIT}件だけを削除します。</p>
            <p>削除されなかった残りの商品は、もう一度削除してください。</p>
            <p class="mb-0">大量に削除する場合は、削除予約をお使いください。</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">キャンセル</button>
            <button type="button" class="btn btn-danger delete-now-limit-ok">${IMMEDIATE_DELETE_LIMIT}件削除</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(el);
    return el;
};
const initDeleteNowLimit = () => {
    document.addEventListener('click', e => {
        const button = e.target.closest('.delete-now-submit');
        if (!button) return;
        const checked = [...document.querySelectorAll('.toggle-delete:checked')];
        if (checked.length <= IMMEDIATE_DELETE_LIMIT) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const el = deleteNowModal();
        const modal = bootstrap.Modal.getOrCreateInstance(el);
        el.querySelector('.delete-now-limit-ok').onclick = () => {
            checked.slice(IMMEDIATE_DELETE_LIMIT).forEach(input => { input.checked = false; });
            document.querySelectorAll('.toggle-all').forEach(input => { input.checked = false; });
            modal.hide();
            // requestSubmit は rails-ujs の確認を通らず、押したボタンの formaction で送る
            button.form.requestSubmit(button);
        };
        modal.show();
    }, true);
};
const mountCsvViewer = () => {
    const container = document.getElementById('csv-viewer');
    if (container) {
        render(<DataViewer />, container);
    }
};

window.initMailTemplateSelect = () => {
    document.querySelectorAll('.mail-template-select').forEach((el) => {
        const id = el.getAttribute('data-id');
        const type = el.getAttribute('data-type');
        const name = el.getAttribute('data-name');
        let url = `/mail-templates/select.js?id=${id}&type=${type}&name=${name}`;
        const selected = el.getAttribute('data-selected');
        if (!isEmpty(selected)) {
            url += `&selected=${selected}`;
        }
        Rails.ajax({type: 'GET', url});
    });
};
window.initOnMailTemplateSelect = () => {
    document.querySelectorAll('.mail-template-select-element').forEach((el) => {
        const showSelected = (id) => {
            const template = el.closest('.mail-template-select');
            const componentId = template?.dataset.id;
            const orderId = template?.dataset.order;
            Rails.ajax({
                type: 'GET',
                url: `/mail-templates/select/${id}.js?order=${orderId}&component_id=${componentId}`,
            });
        };
        const selected = el.dataset.selected;
        if (!isEmpty(selected)) {
            el.value = selected;
            showSelected(selected);
        }
        el.addEventListener('change', () => showSelected(el.value));
    });
};
window.initDeliveryCompanyCheckbox = () => {
    const radios = document.querySelectorAll('[name="order_info[use_delivery_company]"]');
    if (radios.length === 0) return;
    const toggle = () => {
        const selected = Array.from(radios).find((r) => r.checked);
        const checked = selected?.value === 'true';
        const mailSelect = document.getElementById('delivery-company-mail-template-select');
        if (mailSelect) mailSelect.style.display = checked ? '' : 'none';
        const notation = document.getElementById('use_delivery_company_notation');
        if (notation) {
            notation.textContent = checked
                ? '配送業者に配送を委託します。Amazonの送り先は配送業者宛になっています。'
                : '配送を自分で行います。Amazonの送り先は自宅/自分の事務所となっています。';
        }
    };
    radios.forEach((r) => r.addEventListener('change', toggle));
    toggle();
};

const initCSVDownloadButton = () => {
    document.querySelectorAll('.bulk-action').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const form = document.getElementById('the-form');
            if (!form) return false;
            form.innerHTML = '';
            const tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'authenticity_token';
            tokenInput.value = csrfToken();
            form.appendChild(tokenInput);
            const submitInput = document.createElement('input');
            submitInput.type = 'submit';
            submitInput.value = 'submit';
            form.appendChild(submitInput);
            form.setAttribute('action', trigger.getAttribute('href'));
            form.style.display = 'none';
            let checkedItems = 0;
            document.querySelectorAll('.csv-item-check').forEach((checkbox) => {
                if (checkbox.checked) {
                    ++checkedItems;
                    const itemInput = document.createElement('input');
                    itemInput.type = 'hidden';
                    itemInput.name = 'item[]';
                    itemInput.value = checkbox.dataset.id;
                    form.appendChild(itemInput);
                }
            });
            if (checkedItems === 0) {
                alert('チェックボックスが一つも選択されていません');
                return false;
            }
            form.submit();
            return false;
        });
    });
    const bulkAll = document.getElementById('bulk-action-all');
    if (bulkAll) {
        bulkAll.addEventListener('click', () => {
            document.querySelectorAll('.csv-item-check').forEach((el) => {
                el.checked = bulkAll.checked;
            });
        });
    }
};

const initConversionPopup = () => {
    if (!document.getElementById('conversion-popup')) return;
    let __current_i = 0;
    document.querySelectorAll('.amazon-link').forEach((el, i) => {
        const openLink = () => {
            __current_i = i;
            const x = window.open(el.getAttribute('href'));
            setTimeout(() => {
                x.close();
            }, (5 + 10 * Math.random()) * 2000);
        };
        if (i > 0) {
            setTimeout(openLink, i * 25000 + 10000 * Math.random());
        } else {
            openLink();
        }
    });
    window.getConversionCount = () => __current_i;
};

const initContentMargin = () => {
  const content = document.querySelector('.content-wrapper');
  const observer = new ResizeObserver(entries => {
    content.style.marginTop = `${entries[0].borderBoxSize[0].blockSize}px`;
  });

  const target = document.querySelector('.main-header');
  if (target) {
    observer.observe(target);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  OverlayScrollbars(document.querySelector('.sidebar'), {
    className: 'os-theme-light',
    scrollbars: {
      autoHide: "move"
    }
  });
});

const initAjax = () => {
  const loading = document.querySelector('.loading');
  if (!loading) return;

  const addClass = () => loading.classList.add('active');
  const removeClass = () => loading.classList.remove('active');

  // Rails-UJS は data-remote 要素の ajax ライフサイクルを document に
  // bubble させる: ajax:send (送信時) / ajax:complete (完了時)。
  // jQuery 撤去前は $(document).ajaxSend / ajaxStop で監視していた。
  document.addEventListener('ajax:send', addClass);
  document.addEventListener('ajax:complete', removeClass);

  document.addEventListener('click', (e) => {
    if (e.target.dataset?.remote !== 'true') return;
    e.target.addEventListener('ajax:success', removeClass);
    addClass();
  });
};

const initSortable = () => {
  document.querySelectorAll('.sortable').forEach(elem => Sortable.create(elem));
};

const initAmazonPriceInput = () => {
    document.querySelectorAll('.amazon-price-input').forEach(elem => {
        elem.addEventListener('click', () => {
            const currentPrice = elem.getAttribute('data-price');
            const itemName = elem.getAttribute('data-name');
            const price = prompt(`${itemName}Amazon仕入れ価格を変更`, currentPrice);
            const target = elem.getAttribute('data-target');
            Rails.ajax({
                type: 'POST', url: `/api/order-items/${target}/price`, data: new URLSearchParams({price}).toString(),
                success: () => location.reload()
            });
        });
    });
};

const initSearchInput = () => {
    document.querySelectorAll('.js-search-query').forEach(elem => {
        elem.addEventListener('input', debounce(() => {
            Rails.ajax({
                type: 'GET', url: elem.closest('form').getAttribute('action'),
                data: new URLSearchParams({q: elem.value}),
            })
        }, 800));
    });
};

const initOrderInfoCopy = () => {
    document.querySelectorAll('.copy-order-info').forEach(el => {
        el.addEventListener('click', () => {
            const prefecture = el.getAttribute('data-prefecture');
            let address1 = el.getAttribute('data-address1');
            address1 = address1.replace(new RegExp(`^${prefecture}`), '');
            const addressArr = chunk((el.getAttribute('data-address2')).split(''), 16);
            const address2 = (addressArr[0] || []).join('');
            const address3 = (addressArr[1] || []).join('');
            const address4 = (addressArr[2] || []).join('');
            const script = 'let i=(i,v)=>{e=document.querySelector(`.a-popover-inner ${i}`);if(e){e.value=v}};' +
                `i('input[name=address-ui-widgets-enterAddressFullName]','${normalizeKanji(el.getAttribute('data-name'))} ${el.getAttribute('data-order')}');` +
                `i('input[name=address-ui-widgets-enterAddressPhoneNumber]','${el.getAttribute('data-phone')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCodeOne]', '${el.getAttribute('data-zip1')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCodeTwo]','${el.getAttribute('data-zip2')}');` +
                `i('input[name=address-ui-widgets-enterAddressPostalCode]', '${el.getAttribute('data-zip1')}-${el.getAttribute('data-zip2')}');` +
                `i('select[name=address-ui-widgets-enterAddressStateOrRegion]', '${prefecture}');` +
                `i('input[name=address-ui-widgets-enterAddressLine1]','${address1}');` +
                `i('input[name=address-ui-widgets-enterAddressLine2]','${address2}');` +
                `i('input[name=address-ui-widgets-enterBuildingOrCompanyName]', '${address3}');` +
                `i('input[name=address-ui-widgets-enterUnitOrRoomNumber]', '${address4}');` +
                `Array.from(document.querySelectorAll('.a-popover-inner .a-dropdown-prompt'))[1].textContent = '${prefecture}';alert('住所をセットしました！')`;
            copy(script).then(() => flash(`クリップボードに注文情報をコピーしました`));
        });
    });
};


const initPreferHistory = () => {
    document.querySelectorAll('.prefer-history').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            if (history.length > 1) {
                history.back();
            } else {
                history.pushState(null, null, el.getAttribute('href'));
            }
            return false;
        });
    });
};

const initUserDictionaryPreview = () => {
    const container = document.getElementById('user-dictionary-preview');
    if (container) {
        render(<UserDictionaryPreview />, container);
    }
};

const initEditSaveButton = () => {
    document.querySelectorAll('.edit-save-button-form').forEach(form => {
        const editButton = form.querySelector('.edit-button');
        const saveButton = form.querySelector('.save-button');
        const cancelButton = form.querySelector('.cancel-button');
        const readOnlyMemo = form.querySelector('.read-only-memo');
        const editableMemo = form.querySelector('.editable-memo');
        let editMode = false;
        const toggleForm = () =>
            form.querySelectorAll('input[type=text],textarea').forEach(el => {
                if (editMode) {
                    editableMemo.classList.remove('d-none');
                    readOnlyMemo.classList.add('d-none');
                } else {
                    readOnlyMemo.classList.remove('d-none');
                    editableMemo.classList.add('d-none');
                }
            });
        const toggleEdit = (e) => {
            e.preventDefault();
            editMode = !editMode;
            if (editMode) {
                saveButton.classList.remove('d-none');
                cancelButton.classList.remove('d-none');
                editButton.classList.add('d-none');
            } else {
                editButton.classList.remove('d-none');
                saveButton.classList.add('d-none');
                cancelButton.classList.add('d-none');
            }
            toggleForm();
            return false;
        };
        editButton.addEventListener('click', toggleEdit);
        cancelButton.addEventListener('click', toggleEdit);
        toggleForm();
    });
};

// initAll() の即時実行経路 (readyState !== 'loading') でも window.* が
// 未定義にならないよう、グローバル公開は initAll の定義より前に行う。
window.showWowmaCategories = () => {
    const element = document.getElementById('service-categories');
    if (element) {
        const selected = element.getAttribute('data-selected');
        const name = element.getAttribute('data-name');
        const categories = window.gon.service_categories;
        const props = {selected, name, categories};
        render(<WowmaCategories {...props} />, element);
    }
};
window.showDatePickers = showDatePickers;

const initAll = () => {
    showRenewalApiKeyModal();
    window.showWowmaCategories();
    showPriceSettings();
    showProductSearch();
    showDatePickers();
    checkUserMailSettings();
    mountCsvViewer()
    initMailTemplateSelect();
    initOnMailTemplateSelect();
    initDeliveryCompanyCheckbox();
    initToggleAll();
    initDeleteNowLimit();
    initCSVDownloadButton();
    initConversionPopup();
    initContentMargin();
    initAjax();
    initSortable();
    initAmazonPriceInput();
    initSearchInput();
    initOrderInfoCopy();
    initEditSaveButton();
    initUserDictionaryPreview();
    // initPreferHistory();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
